export function saveSettings(settings) {
    if (typeof window === "undefined") {
        return;
    }
    try {
        const raw = window.localStorage?.getItem("ds-one:settings");
        const existing = raw ? JSON.parse(raw) : {};
        const next = { ...existing, ...settings };
        window.localStorage?.setItem("ds-one:settings", JSON.stringify(next));
    }
    catch (error) {
        console.warn("ds-one: unable to persist settings", error);
    }
}
